module.exports = __webpack_public_path__ + "img/18270545.db7611e4.png";